export default "__VITE_ASSET__6PJg0tsA__"